import { useTranslation } from 'react-i18next';
import { Wrench } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card';
import { Skeleton } from 'components/ui/skeleton';
import { useTechniciansList } from 'hooks/useTechnicians';

/**
 * The fifth card of `/admin`: technicians are excluded from `LISTED_ROLES`, so the four counters
 * beside it cannot see them. One directory call at `pageSize=1` — the page is thrown away, only
 * `stats.total` is read. Rendered by its own component so the permission gate mounting it also
 * decides whether the request is fired at all.
 */
const TechnicianStatCard = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useTechniciansList({ orderBy: 'name', order: 'asc', page: 1, pageSize: 1 });
  // A dash, never a 0: a failed call knows nothing, and "no technician" would be a claim.
  const total = data?.stats?.total ?? null;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{t('Technicians')}</CardTitle>
        <Wrench className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-8 w-12" />
        ) : (
          <div className="text-2xl font-bold">{total ?? '—'}</div>
        )}
        <p className="text-xs text-muted-foreground mt-1">{t('Every technician you can see')}</p>
      </CardContent>
    </Card>
  );
};

export default TechnicianStatCard;
